class Review {
  constructor(title, year, rating, description, image) {
    this.title = title;
    this.year = year;
    this.rating = rating;
    this.description = description;
    this.image = image;
  }
}

export default Review;
